import { render } from "./FirmarDescargarFichaRegistroAspirante.vue?vue&type=template&id=a2961bb0"
import script from "./FirmarDescargarFichaRegistroAspirante.vue?vue&type=script&lang=js"
export * from "./FirmarDescargarFichaRegistroAspirante.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__